/**
 * Глобальный singleton «одна активная запись в момент»: старт новой записи
 * отменяет предыдущую, чтобы два поля на экране не писали одновременно.
 */

type CancelFn = () => void

let activeId = 0
let activeCancel: CancelFn | null = null

/** Регистрирует новую активную запись; предыдущая (если была) отменяется. Возвращает id сессии. */
export function claimVoiceSession(cancel: CancelFn): number {
  if (activeCancel) {
    const prev = activeCancel
    activeCancel = null
    prev()
  }
  activeId += 1
  activeCancel = cancel
  return activeId
}

/** Освобождает сессию, если она всё ещё активна. */
export function releaseVoiceSession(id: number): void {
  if (id === activeId) {
    activeCancel = null
  }
}

export function isVoiceSessionActive(id: number): boolean {
  return id === activeId && activeCancel !== null
}
